import { CombinedFamilyQuote } from './combined-family-quote';
import { HomeRiskData } from './home-risk-data';

export class HomeQuoteEmailRequest {
    opportunityId: number;
    email: string;
    producerCuit: string;
    combinedFamilyQuote: CombinedFamilyQuote;
    riskData: HomeRiskData
}
